<div class="flex-box">
    <div *ngIf="fileName.length > 0">{{fileName}}</div>
    <div>
        <button type="button" mat-flat-button [color]="fileName.length == 0 ? 'accent' : 'primary'" 
        (click)="xmlFileInput.click()">Kies bestand...</button>
        <input hidden type="file" #xmlFileInput accept=".xml" (change)="changeXml($event)" name="xmlFile" />
    </div>
</div>
